import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white" data-id="element-197">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-198">
        <div className="bg-amber-50 border-4 border-[#F59E0B] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-199">
          <div className="absolute -top-10 -right-10 text-amber-200 opacity-30" data-id="element-200">
            <ShieldCheck className="w-64 h-64" data-id="element-201" />
          </div>

          <div className="relative z-10" data-id="element-202">
            <div className="w-20 h-20 bg-[#F59E0B] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-203">
              <ShieldCheck className="w-10 h-10 text-white" data-id="element-204" />
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] mb-6" data-id="element-205">
              GARANTÍA TOTAL 7 DÍAS
            </h2>

            <p className="text-xl text-slate-700 font-medium mb-6" data-id="element-206">
              Usá todo el material durante una semana completa.
            </p>

            <p className="text-lg text-slate-600 mb-4" data-id="element-207">Si no sentís:</p>

            <ul className="inline-block text-left space-y-2 mb-8" data-id="element-208">
              <li className="flex items-center text-lg text-slate-700 font-medium" data-id="element-209">
                <span className="text-[#16A34A] mr-3 font-bold" data-id="element-210">✔</span> Más
                orden en tus clases de Lengua
              </li>
              <li className="flex items-center text-lg text-slate-700 font-medium" data-id="element-211">
                <span className="text-[#16A34A] mr-3 font-bold" data-id="element-212">✔</span> Menos
                estrés preparando material
              </li>
              <li className="flex items-center text-lg text-slate-700 font-medium" data-id="element-213">
                <span className="text-[#16A34A] mr-3 font-bold" data-id="element-214">✔</span> Más
                tiempo libre para vos
              </li>
            </ul>

            <div className="bg-white py-4 px-8 rounded-xl border border-amber-200 inline-block" data-id="element-215">
              <p className="text-xl font-bold text-[#1E3A5F]" data-id="element-216">
                Te devolvemos el{' '}
                <span className="text-[#16A34A] font-black" data-id="element-217">
                  100% del dinero
                </span>
                . Sin preguntas. Sin formularios.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}